"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasStagedChanges = exports.getIsScrapedNotificationListValid = exports.getCurrentMarketingFreeSettings = exports.getUpdateMarketingFreeSettings = void 0;

var _reselect = require("reselect");

var _constants = require("settings-ui-sdk/MarketingFreeSettings/constants");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var getUpdateMarketingFreeSettings = function getUpdateMarketingFreeSettings(state) {
  return state.modules.marketing['collected-forms'].staged.updateMarketingFreeSettings;
};

exports.getUpdateMarketingFreeSettings = getUpdateMarketingFreeSettings;

var getCurrentMarketingFreeSettings = function getCurrentMarketingFreeSettings(state) {
  return state.modules.marketing['collected-forms'].entities.marketingFreeSettings;
};

exports.getCurrentMarketingFreeSettings = getCurrentMarketingFreeSettings;
var getIsScrapedNotificationListValid = (0, _reselect.createSelector)([getUpdateMarketingFreeSettings], function (settings) {
  var emails = settings.get(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST);

  if (emails) {
    return emails.reduce(function (sum, next) {
      return sum && _EmailAddress.default.test(next);
    }, true);
  }

  return false;
});
exports.getIsScrapedNotificationListValid = getIsScrapedNotificationListValid;
var getHasStagedChanges = (0, _reselect.createSelector)([getUpdateMarketingFreeSettings, getCurrentMarketingFreeSettings], function (stagedSettings, currentSettings) {
  var stagedEmails = stagedSettings.get(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST);
  var currentEmails = currentSettings.get(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST);
  var stagedCaptureEnabled = stagedSettings.get(_constants.FORM_CAPTURE_ENABLED);
  var currentCaptureEnabled = currentSettings.get(_constants.FORM_CAPTURE_ENABLED);
  return !stagedEmails.equals(currentEmails) || stagedCaptureEnabled !== currentCaptureEnabled;
});
exports.getHasStagedChanges = getHasStagedChanges;